import React, { useState } from 'react';
import { Table, Input, Select, Row, Col, Button } from 'antd';
import Header166 from '../header/header';
const { Option } = Select;


const ProyectosSostenibilidad = () => {
    // Columnas de la tabla
    const columns = [
        { title: 'Código Interno', dataIndex: 'codigoInterno', key: 'codigoInterno', fixed: 'left', },
        { title: 'Nombre Profesional GSE', dataIndex: 'nombreProfesional', key: 'nombreProfesional' },
        { title: 'GT RADICA', dataIndex: 'gtRadica', key: 'gtRadica' },
        { title: 'Depto.', dataIndex: 'departamento', key: 'departamento' },
        { title: 'Municipio', dataIndex: 'municipio', key: 'municipio' },
        { title: 'CODIGO PRE / INI', dataIndex: 'codigoPreIni', key: 'codigoPreIni' },
        { title: 'Línea productiva', dataIndex: 'lineaProductiva', key: 'lineaProductiva' },
        { title: 'NOMBRE PROYECTO / INICIATIVA', dataIndex: 'nombreProyecto', key: 'nombreProyecto' },
        { title: 'ABREVIATURA IMPLEMENTADOR', dataIndex: 'abreviaturaImplementador', key: 'abreviaturaImplementador' },
        { title: 'Proceso que se desarrolla con FAO', dataIndex: 'procesoFao', key: 'procesoFao' },
    ];

    // Datos para la tabla
    const originalData = [
        {
            key: 1,
            codigoInterno: 'ES-0003',
            nombreProfesional: 'DIANA PEREZ',
            gtRadica: 'ARN NARIÑO',
            departamento: 'Nariño',
            municipio: 'San Andrés de Tumaco',
            codigoPreIni: 'PRE-PP-35358',
            lineaProductiva: 'Piscicultura',
            nombreProyecto: 'Fortalecimiento de la pesca artesanal de la Asociación de Pesca de San José- ASOPESJ del municipio de Tumaco, Nariño.',
            abreviaturaImplementador: 'ASOPESJ',
            procesoFao: 'Formulación de plan de sostenibilidad',
        },
        {
            key: 2,
            codigoInterno: 'ES-0004',
            nombreProfesional: 'DIANA PEREZ (Diana Chinchilla)',
            gtRadica: 'ARN NARIÑO',
            departamento: 'Nariño',
            municipio: 'San Andrés de Tumaco',
            codigoPreIni: 'PRE-PP-31802',
            lineaProductiva: 'Comercialización de Coco y cacao',
            nombreProyecto: 'Fortalecimiento en la comercialización de coco y cacao de la Cooperativa Multiactiva Nueva Esperanza del Pacífico - COOMUNTU, del municipio de San Andrés de Tumaco, Nariño.',
            abreviaturaImplementador: 'COOMUNTU',
            procesoFao: 'Formulación de plan de sostenibilidad',
        },
        {
            key: 3,
            codigoInterno: 'ES-0012',
            nombreProfesional: 'JORGE GUTIERREZ / PAULA FORIGUA',
            gtRadica: 'ARN HUILA',
            departamento: 'Huila',
            municipio: 'Neiva',
            codigoPreIni: 'INI-2',
            lineaProductiva: 'Comercialización de café',
            nombreProyecto: 'Encadenamiento productivo de café con enfoque de género “producción, transformación y comercialización de café”',
            abreviaturaImplementador: 'ASOEMANCIPADORAS',
            procesoFao: 'Revisión de Plan de sostenibilidad formulado',
        },
        {
            key: 4,
            codigoInterno: 'ES-0013',
            nombreProfesional: 'JORGE ENRIQUE GUTIERREZ',
            gtRadica: 'ARN HUILA',
            departamento: 'Huila',
            municipio: 'Neiva',
            codigoPreIni: 'PRE-PP-30435',
            lineaProductiva: 'Ganadería Bovina',
            nombreProyecto: 'Fortalecimiento de habilidades productivas para el desarrollo de ganadería semi-intensiva doble propósito, a partir de adecuación de tierras, establecimiento de pastos, semi estabulación e incremento del inventario bovino y en producción de leche y carne en el corregimiento de Vegalarga, municipio de Neiva',
            abreviaturaImplementador: 'COOAGROPAZ',
            procesoFao: 'Revisión de Plan de sostenibilidad formulado',
        },
        {
            key: 5,
            codigoInterno: 'ES-0016',
            nombreProfesional: 'DIANA PEREZ (Diana Chinchilla)',
            gtRadica: 'ARN NARIÑO',
            departamento: 'Nariño',
            municipio: 'San Andrés de Tumaco',
            codigoPreIni: 'PRE-PP-33285',
            lineaProductiva: 'Piscicultura',
            nombreProyecto: 'Implementación de un sistema de producción intensivo de piscicultura para beneficiar a los miembros de la cooperativa COOMMAVE y sus familias, en el municipio de San Andrés de Tumaco, Nariño',
            abreviaturaImplementador: 'COOMMAVE',
            procesoFao: 'Revisión de Plan de sostenibilidad formulado',
        },
        {
            key: 6,
            codigoInterno: 'ES-0022',
            nombreProfesional: 'ANA DELIA BEJARANO',
            gtRadica: 'ARN META Y ORINOQUIA',
            departamento: 'Meta',
            municipio: 'Uribe',
            codigoPreIni: 'PRE-PP-28011',
            lineaProductiva: 'Ganadería Bovina',
            nombreProyecto: 'Implementación de ganadería silvopastoril doble propósito mediante sistema de semi estabulación como alternativa de producción sostenible para la reincorporación de excombatientes de las FARC-EP corregimiento de la julia municipio Uribe',
            abreviaturaImplementador: 'COOPJE',
            procesoFao: 'Formulación de plan de sostenibilidad',
        },
        {
            key: 7,
            codigoInterno: 'ES-0028',
            nombreProfesional: 'MAURICIO CRUZ (Nilson Hernandez)',
            gtRadica: 'ARN CAUCA',
            departamento: 'Cauca',
            municipio: 'Popayán',
            codigoPreIni: 'INI-5',
            lineaProductiva: 'Coworking, catering y atención a la mesa',
            nombreProyecto: 'La Trocha sentires de la montaña (ASOMANUELITA)',
            abreviaturaImplementador: 'ASOMANUELITAS',
            procesoFao: 'Formulación de plan de sostenibilidad',
        },
        {
            key: 8,
            codigoInterno: 'ES-0034',
            nombreProfesional: 'DIANA PEREZ',
            gtRadica: 'ARN ARAUCA',
            departamento: 'Arauca',
            municipio: 'Saravena',
            codigoPreIni: 'INI-9',
            lineaProductiva: 'Piscicultura',
            nombreProyecto: 'Mujeres piscícolas AFPAZ',
            abreviaturaImplementador: 'AFPAZ',
            procesoFao: 'Formulación de plan de sostenibilidad',
        },
        {
            key: 9,
            codigoInterno: 'ES-0036',
            nombreProfesional: 'ANA DELIA BEJARANO (Nilson Hernandez)',
            gtRadica: 'ARN META Y ORINOQUIA',
            departamento: 'Meta',
            municipio: 'Mesetas',
            codigoPreIni: 'PRE-PP-29949',
            lineaProductiva: 'Ganadería Bovina',
            nombreProyecto: 'Implementación de ganadería doble propósito mediante sistemas silvopastoriles, con rotación de potreros en la finca la santa maría en el municipio de mesetas departamento del meta - de la cooperativa COOMULDG (Proceso AETCR MARIANA PAEZ)',
            abreviaturaImplementador: 'COOMULDG',
            procesoFao: 'Formulación de plan de sostenibilidad',
        },
        {
            key: 10,
            codigoInterno: 'ES-0048',
            nombreProfesional: 'MAURICIO CRUZ',
            gtRadica: 'Pendiente Radicación Via SIGOB',
            departamento: 'Cauca',
            municipio: 'Silvia',
            codigoPreIni: 'PRE-PP-28211',
            lineaProductiva: 'Piscicultura',
            nombreProyecto: 'Fortalecer la cadena productiva truchicola',
            abreviaturaImplementador: 'COOMEEP',
            procesoFao: 'Revisión de Plan de sostenibilidad formulado',
        },
        {
            key: 11,
            codigoInterno: 'ES-0049',
            nombreProfesional: 'MAURICIO CRUZ',
            gtRadica: 'Pendiente Radicación Via SIGOB',
            departamento: 'Cauca',
            municipio: 'Caldono',
            codigoPreIni: 'PRE-PP-29926',
            lineaProductiva: 'Porcicultura',
            nombreProyecto: 'Fortalecimiento de la explotación porcina en 105 familias indígenas, campesinas y reincorporados en el municipio de Caldono',
            abreviaturaImplementador: 'COOMEEP',
            procesoFao: 'Revisión de Plan de sostenibilidad formulado',
        },
        {
            key: 12,
            codigoInterno: 'ES-0051',
            nombreProfesional: 'JORGE ENRIQUE GUTIERREZ',
            gtRadica: 'ARN HUILA',
            departamento: 'Huila',
            municipio: 'Neiva',
            codigoPreIni: 'INI-16',
            lineaProductiva: 'Supermercado',
            nombreProyecto: 'Local Comercial (MERCANEIVA)',
            abreviaturaImplementador: 'FEDEAGROPAZ',
            procesoFao: 'Revisión de Plan de sostenibilidad formulado',
        },
        {
            key: 13,
            codigoInterno: 'ES-0055',
            nombreProfesional: 'MAURICIO CRUZ / PAULA FORIGUA',
            gtRadica: 'ARN PUTUMAYO',
            departamento: 'Putumayo',
            municipio: 'Puerto Guzmán',
            codigoPreIni: 'INI-25',
            lineaProductiva: 'Miel',
            nombreProyecto: 'Fortalecimiento proyecto Meliponicultura DE LA ASOCIACION CONSTRUCTORAS DE LIBERTAD - ASOCOLIB “.',
            abreviaturaImplementador: 'ASOCOLIB',
            procesoFao: 'Formulación de plan de sostenibilidad',
        },
        {
            key: 14,
            codigoInterno: 'ES-0057',
            nombreProfesional: 'ANA DELIA BEJARANO',
            gtRadica: 'ARN GUAVIARE',
            departamento: 'Guaviare',
            municipio: 'San José del Guaviare',
            codigoPreIni: 'INI-12',
            lineaProductiva: 'Ganadería Bovina',
            nombreProyecto: 'Unidad Productiva de Reconversión Ganadera - COOJAPAL',
            abreviaturaImplementador: 'COOJAPAL',
            procesoFao: 'Formulación de plan de sostenibilidad',
        },
        {
            key: 15,
            codigoInterno: 'ES-0058',
            nombreProfesional: 'ANA DELIA BEJARANO (Nilson Hernandez)',
            gtRadica: 'ARN META Y ORINOQUIA',
            departamento: 'Meta',
            municipio: 'San Martín',
            codigoPreIni: 'PRE-PP-28244',
            lineaProductiva: 'Ganadería Bovina',
            nombreProyecto: 'Implementación de ganadería doble propósito mediante sistemas silvopastoriles integrado a cultivos forrajeros',
            abreviaturaImplementador: 'DAINCOOP',
            procesoFao: 'Formulación de plan de sostenibilidad',
        }

    ];

    // Estado para los datos de la tabla
    const [data, setData] = useState(originalData);


    // Estados para los filtros
    const [filters, setFilters] = useState({
        municipio: '',
        departamento: '',
        codigoInterno: '',
        gtRadica: '',
        lineaProductiva: '',
    });

    // Maneja los cambios en los filtros
    const handleFilterChange = (key, value) => {
        // Actualiza los filtros
        const updatedFilters = { ...filters, [key]: value };
        setFilters(updatedFilters);

        // Aplica los filtros dinámicamente
        let filteredData = originalData;

        // Filtrar por Municipio
        if (updatedFilters.municipio) {
            filteredData = filteredData.filter((item) =>
                item.municipio.toLowerCase().includes(updatedFilters.municipio.toLowerCase())
            );
        }

        // Filtrar por Departamento
        if (updatedFilters.departamento) {
            filteredData = filteredData.filter((item) =>
                item.departamento.toLowerCase().includes(updatedFilters.departamento.toLowerCase())
            );
        }

        // Filtrar por Código Interno
        if (updatedFilters.codigoInterno) {
            filteredData = filteredData.filter((item) =>
                item.codigoInterno.toLowerCase().includes(updatedFilters.codigoInterno.toLowerCase())
            );
        }

        // Filtrar por GT RADICA
        if (updatedFilters.gtRadica) {
            filteredData = filteredData.filter((item) =>
                item.gtRadica.toLowerCase().includes(updatedFilters.gtRadica.toLowerCase())
            );
        }

        // Filtrar por Línea Productiva
        if (updatedFilters.lineaProductiva) {
            filteredData = filteredData.filter((item) =>
                item.lineaProductiva.toLowerCase().includes(updatedFilters.lineaProductiva.toLowerCase())
            );
        }

        // Actualiza los datos de la tabla
        setData(filteredData);
    };

    // Aplica los filtros a los datos
    const applyFilters = () => {
        let filteredData = originalData;

        if (filters.municipio) {
            filteredData = filteredData.filter((item) =>
                item.municipio.toLowerCase().includes(filters.municipio.toLowerCase())
            );
        }

        if (filters.departamento) {
            filteredData = filteredData.filter((item) =>
                item.departamento.toLowerCase().includes(filters.departamento.toLowerCase())
            );
        }

        if (filters.codigoInterno) {
            filteredData = filteredData.filter((item) =>
                item.codigoInterno.toLowerCase().includes(filters.codigoInterno.toLowerCase())
            );
        }

        if (filters.gtRadica) {
            filteredData = filteredData.filter((item) =>
                item.gtRadica.toLowerCase().includes(filters.gtRadica.toLowerCase())
            );
        }

        if (filters.lineaProductiva) {
            filteredData = filteredData.filter((item) =>
                item.lineaProductiva.toLowerCase().includes(filters.lineaProductiva.toLowerCase())
            );
        }

        setData(filteredData);
    };

    // Resetea los filtros
    const resetFilters = () => {
        setFilters({
            municipio: '',
            departamento: '',
            codigoInterno: '',
            gtRadica: '',
            lineaProductiva: '',
        });
        setData(originalData);
    };


    return (
        <div className="container">
            <div style={{ padding: '20px' }}>
                <Header166 type="s" />

                {/* Filtros */}
                <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>

                    <Col span={4}>
                        <Select
                            placeholder="Seleccione Depto."
                            value={filters.departamento}
                            onChange={(value) => handleFilterChange('departamento', value)}
                            style={{ width: '100%' }}
                        >
                            <Option value="">Seleccione Depto.</Option>
                            <Option value="Nariño">Nariño</Option>
                            <Option value="Huila">Huila</Option>
                            <Option value="Meta">Meta</Option>
                            <Option value="Cauca">Cauca</Option>
                            <Option value="Arauca">Arauca</Option>
                            <Option value="Putumayo">Putumayo</Option>
                            <Option value="Guaviare">Guaviare</Option>
                        </Select>
                    </Col>
                    <Col span={4}>
                        <Select
                            placeholder="Seleccione Municipio"
                            value={filters.municipio}
                            onChange={(value) => handleFilterChange('municipio', value)}
                            style={{ width: '100%' }}
                        >
                            <Option value="">Seleccione Municipio</Option>
                            <Option value="San Andrés de Tumaco">San Andrés de Tumaco</Option>
                            <Option value="Neiva">Neiva</Option>
                            <Option value="Uribe">Uribe</Option>
                            <Option value="Popayán">Popayán</Option>
                            <Option value="Saravena">Saravena</Option>
                            <Option value="Mesetas">Mesetas</Option>
                            <Option value="Silvia">Silvia</Option>
                            <Option value="Caldono">Caldono</Option>
                            <Option value="Puerto Guzmán">Puerto Guzmán</Option>
                            <Option value="San José del Guaviare">San José del Guaviare</Option>
                            <Option value="San Martín">San Martín</Option>
                        </Select>
                    </Col>

                    <Col span={4}>
                        <Input
                            placeholder="Código Interno"
                            value={filters.codigoInterno}
                            onChange={(e) => handleFilterChange('codigoInterno', e.target.value)}
                        />
                    </Col>
                    <Col span={4}>
                        <Input
                            placeholder="GT RADICA"
                            value={filters.gtRadica}
                            onChange={(e) => handleFilterChange('gtRadica', e.target.value)}
                        />
                    </Col>
                    <Col span={4}>
                        <Select
                            placeholder="Seleccione Línea productiva"
                            value={filters.lineaProductiva}
                            onChange={(value) => handleFilterChange('lineaProductiva', value)}
                            style={{ width: '100%' }}
                        >
                            <Option value="">Seleccione Línea productiva</Option>
                            <Option value="Piscicultura">Piscicultura</Option>
                            <Option value="Comercialización de Coco y cacao">Comercialización de Coco y cacao</Option>
                            <Option value="Comercialización de café">Comercialización de café</Option>
                            <Option value="Ganadería Bovina">Ganadería Bovina</Option>
                            <Option value="Coworking, catering y atención a la mesa">Coworking, catering y atención a la mesa</Option>
                            <Option value="Porcicultura">Porcicultura</Option>
                            <Option value="Supermercado">Supermercado</Option>
                            <Option value="Miel">Miel</Option>
                        </Select>
                    </Col>

                    <Col span={4}>

                        <Button style={{ marginLeft: '10px' }} onClick={resetFilters}>
                            Limpiar
                        </Button>
                    </Col>
                </Row>

                {/* Contenedor con desplazamiento horizontal */}
                <div style={{ overflowX: 'auto' }}>


                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="proyectos_sostenibilidad"
                        pagination={{ pageSize: 20 }}
                        bordered
                        scroll={{ y: 500, x: 'max-content' }}
                    />


                </div>
            </div>
        </div>
    );
};

export default ProyectosSostenibilidad;
